import { MasterDetailListEntry } from "@sdbn/common";

export class Task implements MasterDetailListEntry {
  id: number;
  nameDictionaryKey: string;
  translatedLabel: string;

  constructor(tool: any) {
    this.id = tool.id;
    this.nameDictionaryKey = tool.nameDictionaryKey;
  }

  public get listTitle(): string {
    return this.translatedLabel;
  }

  public get listTitleDictionaryKey(): string {
    return null;
  }

  public get listSubTitle(): string {
    return null;
  }

  public get groupIdentifier(): String {
    return null;
  }

  public get childs() : Array<MasterDetailListEntry> {
    return null;
  }

}
